module.exports = __webpack_public_path__ + "static/media/young-man-with-loonguy.e8e5cd3f.png";